import { createSlice } from "@reduxjs/toolkit";
import services from "../services";

interface FavoritePostsState {
    data: Record<string, boolean>;
    loading: boolean;
    error: boolean;
}

const initialState: FavoritePostsState = {
    data: {},
    loading: false,
    error: false,
};

const favoritePostsSlice = createSlice({
    name: "favoritePosts",
    initialState,
    reducers: {
        toggleFavoritePost: (state, action) => {
            const { postId, isFavorite } = action.payload;
            state.data[postId] = isFavorite;
        },
    },
});

export const { toggleFavoritePost } = favoritePostsSlice.actions;

export default favoritePostsSlice.reducer;

export const patchFavoritePost =
    (file_name: string) =>
    async (dispatch: any) => {
        try {
            const response = await services.patchFavoritePosts(file_name);
            dispatch(toggleFavoritePost({ postId: file_name, isFavorite: response.is_favorite }));
            return true;
        } catch (err) {
            console.error("Erro ao favoritar post:", err);
            return false;
        }
    };





